import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { RestApi } from '../../../shared/RestApi/restApi';
import { json } from 'stream/consumers';

interface filterInfo {
  statusMessage: any,
  error: boolean,
  data: any
}

@Injectable({
  providedIn: 'root'
})
export class FitersserviceService {

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private Http: HttpClient, private rest: RestApi) { }

  
  retrieveFilters() {

    return this.Http.get<filterInfo>(this.rest.RETRIEVE_FILTERS, { headers: this.headers })

  }

  insertFilters(value){
    
    return this.Http.post<filterInfo>(this.rest.INSERT_FILTERS,JSON.stringify(value), { headers: this.headers })
  }

  retrieveMultiselect(dnsName, objectId, value){
    return this.Http.get<any>(this.rest.RETRIEVE_MULTISELECT_VALUE + "/" + dnsName + "/" + objectId + "/" + value, {headers : new HttpHeaders({ 'Content-Type': 'plain/text' })});
  }

  retrieveObjects(datasetId) {
    return this.Http.get<filterInfo>(this.rest.RETRIEVE_OBJECT_LABLES + "/" + datasetId, {headers : new HttpHeaders({ 'Content-Type': 'plain/text' })})
  }

  retrieveAlias(objectLable, reportcreationid) {
    return this.Http.get<filterInfo>(this.rest.RETRIEVE_ALIAS + "/" + objectLable + "/" + reportcreationid, {headers : new HttpHeaders({ 'Content-Type': 'plain/text' })})
  }

  deleteFilter(filterId) {
    return this.Http.get<filterInfo>(this.rest.DELETE_FILTER_RECORD + "/" + filterId, {headers : new HttpHeaders({ 'Content-Type': 'plain/text' })})
  }

  retrieveReportCretion(datasetId) {
    return this.Http.get<filterInfo>(this.rest.RETRIEVE_REPORTLINKS_URL + "/" + datasetId, {headers : new HttpHeaders({ 'Content-Type': 'plain/text' })})
  }

  updateFilterRecord(filterId,filterObject){
    return this.Http.put<filterInfo>(this.rest.UPDATE_FILTER+"/"+filterId,JSON.stringify(filterObject),{headers:this.headers});
  }

  getUniqueColumnData(dataObject){
    return this.Http.post<filterInfo>(this.rest.GET_UNIQUECOLUMN_DATA_FROM_S3,JSON.stringify(dataObject),{headers:this.headers});
  }

  getS3ExternalTableData(dataObject){
    return this.Http.post<filterInfo>(this.rest.GET_DATA_FROM_S3_EXTERNAL_TABLE,JSON.stringify(dataObject),{headers:this.headers});
  }

  getAllRowsFromS3File(dataObject){
    return this.Http.post<filterInfo>(this.rest.GET_ALL_ROWS_DATA_FROM_S3_FILE,JSON.stringify(dataObject),{headers:this.headers});
  }
  // 
  getDataFromObjectMetaDataByDnsIdAndCategory(dnsId,objectCategory){
    return this.Http.get<filterInfo>(this.rest.GET_OBJECTMETADATA_BY_DNSID_CATEGORY + "/" + dnsId+"/"+objectCategory, {headers : new HttpHeaders({ 'Content-Type': 'plain/text' })})

  }

}
